(() => {
  if (document.documentElement.hasAttribute('data-st-cz-timer-copy-ready')) return;
  document.documentElement.setAttribute('data-st-cz-timer-copy-ready', 'true');
  const translations = new Map([
    ['Order before:', 'Objednejte do:'],
    ['Objednejte během:', 'Objednejte do:'],
    ['Same-day shipping!', 'Doručení 1-2 pracovní dny'],
    ['Doručení za 1-2 dny', 'Doručení 1-2 pracovní dny'],
    ['Hours', 'Hodiny'], ['Minutes', 'Minuty'], ['Seconds', 'Sekundy']
  ]);
  function translate() {
    document.querySelectorAll('.pp-timer-hold, .pp-timer-title, .pp-timer-description').forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const text = node.nodeValue.trim();
        if (translations.has(text)) node.nodeValue = node.nodeValue.replace(text, translations.get(text));
      }
    });
  }
  let queued = false;
  const observer = new MutationObserver(() => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; translate(); });
  });
  translate();
  observer.observe(document.body, {childList:true, subtree:true});
})();

